import { render, staticRenderFns } from "./card-owner-connect.vue?vue&type=template&id=3f6e565d&scoped=true"
import script from "./card-owner-connect.vue?vue&type=script&lang=js"
export * from "./card-owner-connect.vue?vue&type=script&lang=js"
import style0 from "./card-owner-connect.vue?vue&type=style&index=0&id=3f6e565d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6e565d",
  null
  
)

export default component.exports